import NewsStore from "./news";
import VacanciesStore from "./vacancies";
import CandidatesStore from "./candidates";
import UsersStore from "./users";
import Files from "./files";
import Documents from "./documents";
import ModalWindows from "./modalWindows";

class RootStore {
    constructor() {
        this.newsStore = new NewsStore(this);
        this.vacanciesStore = new VacanciesStore(this);
        this.candidatesStore = new CandidatesStore(this);
        this.usersStore = new UsersStore(this);
        this.filesStore = new Files(this);
        this.documentsStore = new Documents(this);
        this.modalWindows = new ModalWindows(this);
    }
}

const store = new RootStore();

export default store;
